import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Loading = ({ text = 'Loading...', size = 40 }) => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <Box textAlign="center">
                <CircularProgress size={size} />
                <Typography variant="body1" mt={2}>
                    {text}
                </Typography>
            </Box>
        </Box>
    );
}; 

export default Loading;
